<template>
  <BMap
    ref="refBMap"
    :center="center"
    :zoom="zoom"
    :enable-scroll-wheel-zoom="enableScrollWheelZoom"
    :display-options="displayOptions"
    v-bind="$attrs"
    @initd="inited">
    <span>
      <BMapItems :list="overlayList"></BMapItems>
      <slot></slot>
    </span>
  </BMap>
</template>

<script setup lang="ts">
  import BMapItems from './components/BMapItems/index.vue'
  import { ref, onMounted } from 'vue'
  import { type MapDisplayOptions } from 'vue3-baidu-map-gl'
  import { type BMapItemType } from './components/BMapItems/interface'
  defineOptions({
    name: 'ZnMap'
  })

  export interface ZnMapProp {
    overlayList?: Array<BMapItemType> // 地图撒点列表
    center?: string | { lng: number; lat: number } // 地图中心点
    zoom?: number // 地图缩放级别
    enableScrollWheelZoom?: boolean // 允许地图可被鼠标滚轮缩放
    displayOptions?: MapDisplayOptions // 自定义地图属性
    tag?: string // 标签，用于批量处理，在组件中没什么用
    [key: string]: any
  }
  const props = withDefaults(defineProps<ZnMapProp>(), {
    center: '上海市',
    zoom: 12,
    loadingBgColor: '#00223a',
    enableScrollWheelZoom: true,
    displayOptions: {
      indoor: false,
      poiText: false,
      poiIcon: false,
      building: false
    }
  })

  const emits = defineEmits(['register'])
  // const refBMap = ref(null)
  const refBMap = ref(null)

  const inited = ({ map, BmapGL, instance }) => {
    console.log(map, BmapGL, instance)
    emits('register', map, instance)
  }

  defineExpose({
    bmap: refBMap
  })
</script>

<style lang="scss" scoped></style>
